module.exports = __webpack_public_path__ + "img/communities.ec8fd54a.png";